import React, { useState } from "react";
import axios from "axios";


const useSOP = ({
    onFinish = ({ axiosMode, status, values }) => { },
    onBefore = ({ axiosMode, status }) => { },
    onSOPFinish = ({ axiosMode, status, values }) => { },
    onSOPBefore = ({ axiosMode, status }) => { },
}) => {
    const [data, setData] = useState([])
    const [formUseData, setFormUseData] = useState([])
    const getSOPData = (params) => {
        onBefore({
            axiosMode: "get"
        })
        return axios.get('/pmis/ai_flow_automation/sop', {
            params: params,
        })
            .then((response) => {
                let data = response.data
                setData(data?.data)
                if (data) {
                    onFinish({
                        axiosMode: "get",
                        status: "success",
                        values: data?.data
                    })
                }
                else {
                    onFinish({
                        axiosMode: "get",
                        status: "failure"
                    })
                }
                return {
                    ...data
                }
            });
    }
    const getSOPFormUseData = (params) => {
        onBefore({
            axiosMode: "get"
        })
        return axios.get('/pmis/ai_flow_automation/sop', {
            params: params,
        })
            .then((response) => {
                let data = response.data
                setFormUseData(data?.data?.[0])
                if (data) {
                    onFinish({
                        axiosMode: "get",
                        status: "success",
                        values: data?.data?.[0]
                    })
                }
                else {
                    onFinish({
                        axiosMode: "get",
                        status: "failure"
                    })
                }
                return {
                    ...data?.[0]
                }
            });
    }
    const [displayData, setdisplayData] = useState([])
    const getSOPDisplayData = (params) => {
        onBefore({
            axiosMode: "get"
        })
        return axios.get('/pmis/ai_flow_automation/ongoing_sop', {
            params: params,
        })
            .then((response) => {
                let data = response.data
                setdisplayData(data?.data)
                if (data) {
                    onFinish({
                        axiosMode: "get",
                        status: "success",
                        values: data?.data
                    })
                }
                else {
                    onFinish({
                        axiosMode: "get",
                        status: "failure"
                    })
                }
                return {
                    ...data
                }
            });
    }
    const postSOPData = (data) => {
        onBefore({
            axiosMode: "post"
        })
        axios.post('/pmis/ai_flow_automation/sop',
            data
        )
            .then((response) => {
                let responseData = response.data
                let status = responseData?.status
                if (status !== "success") {
                    onFinish({
                        axiosMode: "post",
                        status: "failure"
                    })
                } else {
                    onFinish({
                        axiosMode: "post",
                        status: "success",
                        values: responseData
                    })
                }
            })
            .catch(() => {
                onFinish({
                    axiosMode: "post",
                    status: "failure"
                })
            })

    }
    const patchSOPData = (data) => {
        onBefore({
            axiosMode: "patch"
        })
        axios.patch('/pmis/ai_flow_automation/sop',
                data
            
        )
            .then((response) => {
                let responseData = response.data
                let status = responseData?.status
                if (status !== "success") {
                    onFinish(
                        {
                            axiosMode: "patch",
                            status: "failure"
                        }
                    )
                }
                else {
                    onFinish(
                        {
                            axiosMode: "patch",
                            status: "success",
                            values: responseData
                        }
                    )
                }
            })
            .catch(() => {
                onFinish(
                    {
                        axiosMode: "patch",
                        status: "failure"
                    }
                )
            })
    }
    const deleteSOPData = (data) => {
        onBefore({
            axiosMode: "delete"
        })
        axios.delete('/pmis/ai_flow_automation/sop',
            {
                data
            }
        )
            .then((response) => {
                let responseData = response.data
                let status = responseData?.status
                if (status === "fail") {
                    onFinish(
                        {
                            axiosMode: "delete",
                            status: "failure"
                        }
                    )
                }
                else {
                    onFinish(
                        {
                            axiosMode: "delete",
                            status: "success",
                            values: responseData
                        }
                    )
                }
            })
            .catch(() => {
                onFinish(
                    {
                        axiosMode: "delete",
                        status: "failure"
                    }
                )
            })
    }

    const patchSOPStepVerifyData = (data) => {
        onBefore({
            axiosMode: "patch"
        })
        axios.patch('/pmis/ai_flow_automation/ongoing_sop/ongoing_step/verify',
                data
            
        )
            .then((response) => {
                let responseData = response.data
                let status = responseData?.status
                if (status !== "success") {
                    onSOPFinish(
                        {
                            axiosMode: "patch",
                            status: "failure"
                        }
                    )
                }
                else {
                    onSOPFinish(
                        {
                            axiosMode: "patch",
                            status: "success",
                            values: responseData
                        }
                    )
                }
            })
            .catch(() => {
                onSOPFinish(
                    {
                        axiosMode: "patch",
                        status: "failure"
                    }
                )
            })
    }
    return {
        SOPData: data,
        SOPFormUseData: formUseData, 
        DisplayData: displayData, 
        getSOPFormUseData, 
        getSOPData,
        getSOPDisplayData,
        postSOPData,
        patchSOPData,
        deleteSOPData,
        patchSOPStepVerifyData, 
    }
}
export { useSOP }
